import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';

/**
 * Add Location Google Review Input Schema
 */
export const addLocationGoogleReviewValidationSchema = z.object({
  state: z.string({ required_error: 'State is required' }),
  names: z.array(z.string({ required_error: 'Names are required' })),
});

export type TAddLocationGoogleReviewValidation = z.infer<typeof addLocationGoogleReviewValidationSchema>;
export type TAddLocationGoogleReviewPayload = TAddLocationGoogleReviewValidation;
export type TAddLocationGoogleReviewResponse = ApiResponse<{
  message: string;
}>;

export const addLocationGoogleReview = async (
  payload: TAddLocationGoogleReviewPayload
): Promise<TAddLocationGoogleReviewResponse> => {
  const url = `/integration/google-review/location`;

  const payloadData = {
    state: payload.state,
    names: payload.names,
  };

  return axiosInstance.post(url, payloadData);
};

/**
 * Use Add Location Google Review React-Query Hook
 */
type UseAddLocationGoogleReviewOptions = {
  mutationConfig?: TypedMutationConfig<typeof addLocationGoogleReview, AxiosErrorCustom>;
};

export const useAddLocationGoogleReview = ({ mutationConfig }: UseAddLocationGoogleReviewOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: addLocationGoogleReview,
    ...restConfig,
  });
};
